// src/api/examDetails.js
import { getRequest, postRequest } from "./api";

// ✅ Get Exam Details
export const getExamDetails = async () => {
  return getRequest("/user/exam-details");
};

// ✅ Save (POST) Exam Details
export const saveExamDetails = async (data) => {
  return postRequest("/user/exam-details", data);
};
